import { render, staticRenderFns } from "./ReservationListView.vue?vue&type=template&id=59aa8820&scoped=true"
import script from "./ReservationListView.vue?vue&type=script&lang=js"
export * from "./ReservationListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa8820",
  null
  
)

export default component.exports